require("@rails/ujs").start()
import "channels";
import "controllers";
require("leaderboard");

